export default __webpack_public_path__ + "static/media/ic_mini_ocbbank.603cb86b.svg";